import script from "./ApplicationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationView.vue?vue&type=style&index=0&id=b4c3c126&lang=scss"

const __exports__ = script;

export default __exports__